module.exports = __webpack_public_path__ + "img/ind_even_presipitacion_hover.ca6b63c6.png";